import React, { useState } from "react";
import Loader from "../../components/Loader";
import { notifyError, notifySuccess } from "../../utils/functions";
import { imgArr } from "../../assets/images";
import countryCodes from "./countryCodes.json";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    countryCode: "+1",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Reset error for the field
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{7,15}$/;

    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Invalid email format";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!phoneRegex.test(formData.phone))
      newErrors.phone = "Invalid phone number format";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/inquiry`;
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.email,
          phone: `${formData.countryCode}${formData.phone}`,
        }),
      });

      if (!response.ok) {
        throw new Error("SignIn failed! Check credentials.");
      }

      const data = await response.json();
      notifySuccess(data.message);
    } catch (error) {
      notifyError(error?.message || "Failed to submit inquiry.");
    } finally {
      setLoading(false);
    }
    // Reset form
    setFormData({
      fullName: "",
      email: "",
      phone: "",
      countryCode: "+1",
    });
    setErrors({});
  };

  return (
    <section className="contact-section wapper">
      {loading && <Loader />}
      <div className="contact-details">
        <div className="contact-left">
          <h2>Get in Touch</h2>
          <img src={imgArr.email} alt="email" width={30} height={30} />
          <p>
            <strong>Email Address</strong>
          </p>
          <a href="mailto:annabel@circuit-app.com">annabel@circuit-app.com</a>
        </div>

        <div
          className="contact-right"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <h3>Lets connect</h3>
          <form className="details-form" onSubmit={handleSubmit} noValidate>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name*"
              value={formData.fullName}
              onChange={handleChange}
            />
            {errors.fullName && (
              <small className="error">{errors.fullName}</small>
            )}

            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <small className="error">{errors.email}</small>}

            <div className="phone-container">
              <select
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
              >
                {countryCodes.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item?.short} ({item?.code})
                  </option>
                ))}
              </select>
              <input
                type="tel"
                name="phone"
                placeholder="Phone number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            {errors.phone && <small className="error">{errors.phone}</small>}

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
